/* --------------------------------------------------------------------------
   LUBIN — la galerie produit : ce qui s'ajoute le 10/10/2026 au carrousel de
   lubin-v5-produit.js (qui garde « suivant » et le choix de la contenance).
     · la flèche « précédent » ;
     · les repères en pied d'image (un par vue, cliquables) ;
     · le glissé au doigt sur téléphone ;
     · les flèches ← → du clavier quand la galerie a le focus.
   On passe TOUJOURS par scene.lubinMontre(n) : c'est lui qui arrête le film
   quand on quitte sa vue. Les repères suivent la vue active par observation
   de sa classe, quelle que soit la cause du changement (flèche, pastille de
   contenance, repère).
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  function active(vues) {
    for (var n = 0; n < vues.length; n++) if (vues[n].classList.contains('lpp__vue--active')) return n;
    return 0;
  }

  function prepare(scene) {
    if (scene.dataset.galeriePrete || !scene.lubinMontre || !scene.lubinVues) return;
    scene.dataset.galeriePrete = '1';
    var vues = scene.lubinVues;
    var montre = scene.lubinMontre;
    var prec = scene.querySelector('[data-lpp-precedent]');
    var reperes = scene.querySelector('[data-lpp-reperes]');
    if (vues.length < 2) return;            // une seule vue : ni flèches ni repères

    function va(pas) { montre((active(vues) + pas + vues.length) % vues.length); }

    if (prec) {
      prec.hidden = false;
      prec.addEventListener('click', function () { va(-1); });
    }

    /* les repères */
    var traits = [];
    if (reperes) {
      var mot = reperes.dataset.mot || 'Image';
      vues.forEach(function (v, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lpp__repere';
        b.setAttribute('aria-label', mot + ' ' + (n + 1) + ' / ' + vues.length);
        b.addEventListener('click', function () { montre(n); });
        reperes.appendChild(b);
        traits.push(b);
      });
      reperes.hidden = false;
    }
    function maj() {
      var a = active(vues);
      traits.forEach(function (t, n) { t.setAttribute('aria-current', n === a ? 'true' : 'false'); });
    }
    maj();
    var obs = new MutationObserver(maj);
    vues.forEach(function (v) { obs.observe(v, { attributes: true, attributeFilter: ['class'] }); });

    /* le glissé : horizontal franc seulement, pour ne pas voler le défilement
       vertical de la page */
    var x0 = null, y0 = null;
    scene.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    scene.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) va(dx < 0 ? 1 : -1);
    }, { passive: true });

    /* le clavier */
    scene.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { va(1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { va(-1); e.preventDefault(); }
    });
  }

  function demarre() {
    document.querySelectorAll('[data-lpp-scene]').forEach(prepare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarre);
  else demarre();
  document.addEventListener('shopify:section:load', function () { setTimeout(demarre, 0); });
})();
